import { useContext } from 'react';
import { ConfigContext } from '../context';
const useGetImages = () => {
    const { config } = useContext(ConfigContext);
    const { assets } = config.hosts;
    return {
        success: `${assets}assets/account-services/cli_success.svg`,
        error: `${assets}assets/account-services/technical_error_cat.svg`,
        ladyWarning: `${assets}assets/account-services/lady-warning.svg`,
        calendar: `${assets}assets/account-services/calendar.svg`
    };
};
export default useGetImages;
